"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _cssTransition = _interopRequireDefault(require("../utils/css-transition"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _numbers = require("../utils/numbers");

var _progress = require("./progress.styles");

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _assertion = require("../utils/assertion");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  striped: false,
  animated: true,
  shadow: false,
  indeterminated: false,
  value: 0,
  min: 0,
  max: 100
};
const preClass = 'nextui-progress';

const Progress = ({
  value: valueProp,
  max,
  min,
  striped,
  animated,
  shadow,
  indeterminated,
  css,
  ...props
}) => {
  const value = (0, _react.useMemo)(() => valueProp > max ? max : valueProp < min ? min : valueProp, [valueProp, min, max]);
  const percent = (0, _react.useMemo)(() => (0, _numbers.valueToPercent)(value, min, max), [value, min, max]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_progress.StyledProgress, {
    role: "progressbar",
    indeterminated: indeterminated,
    css: {
      'nextui-progress-wrapper-enter': {
        opacity: 0
      },
      '.nextui-progress-wrapper-enter-active': {
        opacity: 1,
        width: `${percent}%`
      },
      ...css
    },
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_cssTransition.default, {
      visible: true,
      name: `${preClass}-wrapper`,
      enterTime: 10,
      leaveTime: 20,
      clearTime: 300,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_progress.StyledProgressBar, {
        className: (0, _clsx.default)(`${preClass}-bar`, {
          [`${preClass}-striped`]: striped,
          [`${preClass}-indeterminated`]: indeterminated
        }),
        "aria-valuenow": value,
        "aria-valuemin": min,
        "aria-valuemax": max,
        striped: striped,
        animated: animated,
        shadow: shadow,
        indeterminated: indeterminated,
        ...props
      })
    })
  });
};

if (_assertion.__DEV__) {
  Progress.displayName = 'NextUI - Progress';
}

Progress.toString = () => '.nextui-progress';

const MemoProgress = /*#__PURE__*/_react.default.memo(Progress);

var _default = (0, _withDefaults.default)(MemoProgress, defaultProps);

exports.default = _default;
module.exports = exports.default;